import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=9e50541a&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=9e50541a&prod&lang=stylus&scoped=true"
import style1 from "./detailDialog.vue?vue&type=style&index=1&id=9e50541a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e50541a",
  null
  
)

export default component.exports